class BookedSeva {
    sevaname : string;
    quantity: number;
    amount: number;
}

export class SevaBookingResponse {
    id: number;
    sevadate:string;
    sevaspecialrequest:string;
    amountpaid:number;
    name : string;
    phone : number;
    gotra : string;
    nakshatra : number;
    numpersons:number;
    amountpending: number;
    amounttotal:number;
    paymenttype:string;
    paymentnote:string;
    receiptno:string;
    bookingdate:number;
    reporting_time:string;
    tokendetails:string;
    bookinguser: string;
    sevas: BookedSeva[];
    sevatime?:string;
}


// WEBPACK FOOTER //
// ./src/models/SevaBookingResponse.ts